
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenWeatherMetrics {

    advisoryOnlyEpisodes: number;
    associatedEpisodes: number;
    associatedEvents: number;
    associationRate: number;
    compoundEpisodes: number;
    compoundShare: number;
    curveReviewFraction: number;
    episodes: number;
    episodesPerYear: number;
    eventReviewFraction: number;
    impactSupport: string;
    medianBurden: number;
    medianPeak: number;
    medianRecovery: number;
    warningAndAdvisoryEpisodes: number;
    warningOnlyEpisodes: number;
    weatherSupport: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherMetrics: GenWeatherMetrics);

    constructor( input?: GenWeatherMetrics ) {
        if ( input && typeof input !== 'number' ) {
            this.advisoryOnlyEpisodes = input.advisoryOnlyEpisodes; // int [number]
            this.associatedEpisodes = input.associatedEpisodes; // int [number]
            this.associatedEvents = input.associatedEvents; // int [number]
            this.associationRate = input.associationRate; // float [number]
            this.compoundEpisodes = input.compoundEpisodes; // int [number]
            this.compoundShare = input.compoundShare; // float [number]
            this.curveReviewFraction = input.curveReviewFraction; // float [number]
            this.episodes = input.episodes; // int [number]
            this.episodesPerYear = input.episodesPerYear; // float [number]
            this.eventReviewFraction = input.eventReviewFraction; // float [number]
            this.impactSupport = input.impactSupport; // string [string]
            this.medianBurden = input.medianBurden; // float [number]
            this.medianPeak = input.medianPeak; // float [number]
            this.medianRecovery = input.medianRecovery; // float [number]
            this.warningAndAdvisoryEpisodes = input.warningAndAdvisoryEpisodes; // int [number]
            this.warningOnlyEpisodes = input.warningOnlyEpisodes; // int [number]
            this.weatherSupport = input.weatherSupport; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherMetrics[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherMetrics(a));
        } else {
          return [];
        }
    }
}

